import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { logout, roleSelector, tokenSelector } from '../../../Store/authSlice';
import { NavigateOptions, useNavigate } from 'react-router-dom';

export const useHeader = () => {
  const token = useAppSelector(tokenSelector);
  const role = useAppSelector(roleSelector);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const signOut = () => {
    dispatch(logout());
    navigate('/', { replace: true });
  };

  const navigateTo = (target: string, options?: NavigateOptions) => {
    navigate(target, options);
  };
  return { role, token, signOut, navigateTo };
};
